import { EntityState } from '@reduxjs/toolkit';

import { CarItemType } from '@/interfaces/cars.interfaces';

export type ComparisonItemType = {
  id: CarItemType['id'];
  addedBy: number;
};

export type ComparisonStateType = EntityState<
  ComparisonItemType,
  ComparisonItemType['id']
> & {
  selected: Array<CarItemType['id']>;
  isShowDifference: boolean;
  isIrrelevant?: boolean;
};

export enum ComparisonShiftDirectionEnum {
  Left = 'left',
  Right = 'right',
}
